import React from 'react';

export const Logo = ({ size = 'default' }) => {
  const sizes = {
    small: { height: 32, fontSize: 14 },
    default: { height: 40, fontSize: 18 },
    large: { height: 56, fontSize: 24 },
  };

  const { height, fontSize } = sizes[size] || sizes.default;

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '12px' }}>
      {/* Logo Image */}
      <img
        src="/baiboticon.png"
        alt="BAiBOT inDriver Logo"
        style={{
          height: `${height}px`,
          width: 'auto',
          objectFit: 'contain',
        }}
      />

      {/* Text Logo */}
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
        <span
          style={{
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
            fontSize: `${fontSize}px`,
            fontWeight: 700,
            color: '#00FFD1',
            letterSpacing: '0.5px',
          }}
        >
          BAiBOT
        </span>
        <span
          style={{
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
            fontSize: `${fontSize * 0.65}px`,
            fontWeight: 500,
            color: '#FFFFFF',
            letterSpacing: '1px',
            marginTop: '-2px',
          }}
        >
          inDriver
        </span>
      </div>
    </div>
  );
};
